import { createGlobalStyle } from "styled-components";

const Global = createGlobalStyle`
  *{
    font-family: 'Montserrat', sans-serif;
    box-sizing: border-box;
  }

  body {
      margin: 0;
      padding: 0;
  }    
`;

export default Global;
